module.exports = __webpack_public_path__ + "img/icon-like.3e34e064.svg";